import React from "react";
import PaginatedTable from '../components/paginatedTable'

import StandardButton from "../components/standardButton";
import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NewRoleDialog from "../components/newRoleDialog";

const items = [
  { id: 1, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 2, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 3, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 4, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 5, permission: 'AI', fullAccess: false, guest: 2121, retailhubAdmins: false,},
  { id: 6, permission: 'AI', fullAccess: false, guest: 2121, retailhubAdmins: false,},
  { id: 7, permission: 'AI', fullAccess: false, guest: 2121, retailhubAdmins: false,},
  { id: 8, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 9, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 10, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 11, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 12, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 13, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 14, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 15, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 16, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 17, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
  { id: 18, permission: 'AI', fullAccess: true, guest: 2121, retailhubAdmins: true,},
];

function IconColumn(params) {
  if(params.value)
    return (
      <div className="flex h-full items-center">
        <div className="bg-green-500 w-10 h-10 flex items-center justify-center rounded-full">
          <DoneIcon />
        </div>
      </div>
    )
  else
    return (
    <div className="flex h-full items-center">
      <div className="bg-red-500 w-10 h-10 flex items-center justify-center rounded-full">
        <CancelIcon />
      </div>
    </div>
    )
}

export default function RolesAndPermissions() {
  const [rows, setRows] = React.useState(items);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const header = [
    { field: 'permission', headerName: 'Permission', width: 200 },
    { 
      field: 'fullAccess', 
      headerName: 'Full access', 
      width: 130,
      type: 'custom',
      renderCell: IconColumn, 
    },
    { field: 'guest', headerName: 'Guest', type: 'number', width: 200 },
    { 
      field: 'retailhubAdmins', 
      headerName: 'RetailHub Admins', 
      width: 200,
      type: 'custom',
      renderCell: IconColumn, 
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
  
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }
  
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    }
  ];

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (!!editedRow && editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  return (
    <div className="p-5 flex justify-center items-center h-full max-h-[100vh]">
      <div className="p-5 flex items-center justify-center w-full h-full max-h-full bg-[#191919] rounded-2xl">
        <div className="flex flex-col gap-5 max-w-full max-h-full w-full h-full">
          
          <div className="flex justify-between items-center w-full">
            <h1 className="text-6xl font-medium">Manage Roles & Permissions</h1>
            <NewRoleDialog />
          </div>
          <div className="flex gap-4 items-center">
            <NotificationsActiveIcon sx={{color: "rgb(var(--global-color-primary))"}}/>
            <span>SuperAdmin should be able to analyse and produce a report of the registered companies through its given keywords.</span>
          </div>
          <PaginatedTable header={header} items={items} />
        </div>
      </div>
    </div>
  )
}